import $ from 'jquery';

export default function scrolled (scrolled_state_class, navbar_id) {
    // const scrolled_state_class = "scrolled"
	// const navbar_id = "header"
	const navbar = document.getElementById(navbar_id)
	const scroll = document.documentElement.scrollTop

	window.onload = (event) => {
		if (scroll > 0) {
			navbar.classList.add(scrolled_state_class);
		}
	}

	const onScroll = () => {
		const scroll = document.documentElement.scrollTop
		if (scroll > 0) {
			navbar.classList.add(scrolled_state_class);
		} else {
			navbar.classList.remove(scrolled_state_class)
		}
	}
	window.addEventListener('scroll', onScroll)
}